import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const A = styled.a.attrs({
  tabIndex: 0,
})`
  font-size: ${({ size }) => size}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  color: #f29e7f;
  text-decoration: ${({ noUnderline }) => (noUnderline ? 'none' : 'underline')};
  cursor: pointer;
  ${({ capitalize }) => capitalize && 'text-transform:capitalize;'};
  &:hover {
    color: #ef8763;
  }
`;

A.defaultProps = {
  noUnderline: false,
  capitalize: false,
  size: 12,
  lineHeight: 15
};

A.propTypes = {
  noUnderline: PropTypes.bool.isRequired,
  capitalize: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired,
  lineHeight: PropTypes.number.isRequired
};

export default A;
